import { ClonedStatesController } from "./inputs/ClonedStatesController";
export class OperationInputsController {
  constructor(operationContainer) {
    this.operationContainer = operationContainer;
  }
  inputsCount() {
    return this.operationContainer.inputsCount();
  }
  initInputsClonedState(states) {
    if (!this._clonedStatesController) {
      this._clonedStatesController = new ClonedStatesController(this);
      this._clonedStatesController.initInputsClonedState(states);
    }
  }
  cloneRequired(index) {
    var _a;
    const state = (_a = this._clonedStatesController) == null ? void 0 : _a.clone_required_state(index);
    if (state != null) {
      return state;
    }
    return true;
  }
  override_cloned_state(state) {
    var _a;
    (_a = this._clonedStatesController) == null ? void 0 : _a.override_cloned_state(state);
  }
}
